export enum FilterDepthEnum {
    Year = 'Year',
    Month = 'Month',
    Day = 'Day', 
    Hour = 'Hour',
    Minute = 'Minute'
}